export const device = {
  mobile: `@media (max-width: 768px)`
};
